import React from 'react';
import './Input.css';

function Input({
  error = false,
  size = 'md',
  prefix = null,
  suffix = null,
  className = '',
  ...rest
}) {
  const wrapperClasses = [
    'ui-input',
    `ui-input--${size}`,
    error ? 'ui-input--error' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={wrapperClasses}>
      {prefix && <span className="ui-input__affix ui-input__affix--prefix">{prefix}</span>}
      <input className="ui-input__field" aria-invalid={error || undefined} {...rest} />
      {suffix && <span className="ui-input__affix ui-input__affix--suffix">{suffix}</span>}
    </span>
  );
}

export default Input;
